import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Radio, Row, Select, Space } from "antd";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

import * as Types from "../commons/typeDTO";
import * as String from "../commons/string";
import * as Request from "../commons/request";

function RentCarDetail({
    editMode,
    rentCar,
    rentCarIds,
    onChangeRentCar,
}: {
    editMode: string;
    rentCar?: Types.RentCarDto;
    rentCarIds?: number[];
    onChangeRentCar?: (rentCar: Types.RentCarDto) => void;
}) {
    const [form] = Form.useForm();
    const [regions, setRegions] = useState<Array<Types.RentRegionDto>>();
    const [cars, setCars] = useState<Array<Types.CarDto>>();
    const [options, setOptions] = useState<Array<Types.RentOptionDto>>();
    const [restrictions, setRestrictions] = useState<Array<Types.RentRestrictionDto>>();

    useEffect(() => {
        requestGetRegions();
        requestGetCars();
        requestGetRestrictions();
        requestGetOptions();
    }, []);

    useEffect(() => {
        if (rentCar) {
            form.setFieldsValue({
                ...rentCar,
                rentRestrictions: rentCar?.rentRestrictions?.map((restriction) => restriction?.rentRestrictionId),
                rentOptions: rentCar?.rentOptions?.map((option) => option?.rentOptionId),
                unavailable: rentCar?.unavailable ?? false,
                waiting: rentCar?.waiting ?? false,
                repairing: rentCar?.repairing ?? false,
            });
        } else {
            form.resetFields();
        }
    }, [rentCar]);

    const onFinish = (values: any) => {
        onChangeRentCar && onChangeRentCar(values);
    };

    //get rentRegions
    const requestAxiosGetRegions = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_REGION_LIST_URL);
        return response.data;
    };

    const { loading: loadingGetRegions, error: errorGetRegions, data: resultGetRegions, execute: requestGetRegions } = useAsyncAxios(requestAxiosGetRegions);

    useEffect(() => {
        if (resultGetRegions === null) return;

        console.log("resultGetRegions", resultGetRegions);
        setRegions(resultGetRegions.rentRegions);
    }, [resultGetRegions]);

    useEffect(() => {
        if (errorGetRegions === null) return;

        console.log("errorGetRegions", errorGetRegions);
    }, [errorGetRegions]);

    //get cars
    const requestAxiosGetCars = async () => {
        const response = await utilAxiosWithAuth().get(Request.CARS_URL);
        return response.data;
    };

    const { loading: loadingGetCars, error: errorGetCars, data: resultGetCars, execute: requestGetCars } = useAsyncAxios(requestAxiosGetCars);

    useEffect(() => {
        if (resultGetCars === null) return;

        console.log("resultGetCars", resultGetCars);
        setCars(resultGetCars.cars);
    }, [resultGetCars]);

    useEffect(() => {
        if (errorGetCars === null) return;

        console.log("errorGetCars", errorGetCars);
    }, [errorGetCars]);

    //get resctrictions
    const requestAxiosGetRestrictions = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_RESTRICTIONS_URL);
        return response.data;
    };

    const {
        loading: loadingGetRestrictions,
        error: errorGetRestrictions,
        data: resultGetRestrictions,
        execute: requestGetRestrictions,
    } = useAsyncAxios(requestAxiosGetRestrictions);

    useEffect(() => {
        if (resultGetRestrictions === null) return;

        console.log("resultGetRestrictions", resultGetRestrictions);
        setRestrictions(resultGetRestrictions.rentRestrictions);
    }, [resultGetRestrictions]);

    useEffect(() => {
        if (errorGetRestrictions === null) return;

        console.log("errorGetRestrictions", errorGetRestrictions);
    }, [errorGetRestrictions]);

    //get options
    const requestAxiosGetOptions = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_OPTIONS_URL);
        return response.data;
    };

    const { loading: loadingGetOptions, error: errorGetOptions, data: resultGetOptions, execute: requestGetOptions } = useAsyncAxios(requestAxiosGetOptions);

    useEffect(() => {
        if (resultGetOptions === null) return;

        console.log("resultGetOptions", resultGetOptions);
        setOptions(resultGetOptions.rentOptions);
    }, [resultGetOptions]);

    useEffect(() => {
        if (errorGetOptions === null) return;

        console.log("errorGetOptions", errorGetOptions);
    }, [errorGetOptions]);

    const onValuesChange = (changeValues: any, allValues: any) => {
        if (changeValues?.car?.carId) {
            const car = cars?.find((car) => car.carId === changeValues?.car?.carId);
            form.setFieldValue(["car", "carType", "typeName"], car?.carType?.typeName);
            form.setFieldValue(["car", "makerName"], car?.makerName);
        }
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish} onValuesChange={onValuesChange}>
                <Space size={20} direction="vertical" style={{ width: "100%" }}>
                    <div>
                        <Row style={{ width: "100%" }}>
                            <Col xs={{ span: 0 }}>
                                <Form.Item className="searchForm" name="rentCarId" label="차량번호">
                                    <span>{rentCar?.rentCarId || String.dash}</span>
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item
                                    className="searchForm"
                                    name={["car", "carId"]}
                                    label="차량번호"
                                    rules={[
                                        {
                                            required: true,
                                            message: "차량번호를 선택해주세요",
                                        },
                                    ]}
                                >
                                    {editMode === "none" ? (
                                        <span>{rentCar?.car?.carNumber || String.dash}</span>
                                    ) : (
                                        <Select
                                            placeholder="차량번호"
                                            showSearch
                                            optionFilterProp="label"
                                            options={cars?.map((car) => ({ value: car.carId, label: car.carNumber }))}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name={["car", "carType", "typeName"]} label="차량타입">
                                    {editMode === "none" ? <span>{rentCar?.car?.carType?.typeName || String.dash}</span> : <Input disabled />}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name={["car", "makerName"]} label="제조사">
                                    {editMode === "none" ? <span>{rentCar?.car?.makerName || String.dash}</span> : <Input disabled />}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item
                                    className="searchForm"
                                    name={["rentRegion", "rentRegionId"]}
                                    label="차고지"
                                    rules={[
                                        {
                                            required: true,
                                            message: "차고지를 선택해주세요",
                                        },
                                    ]}
                                >
                                    {editMode === "none" ? (
                                        <span>{rentCar?.rentRegion?.rentRegionName || String.dash}</span>
                                    ) : (
                                        <Select
                                            placeholder="차고지"
                                            options={regions?.map((region) => ({ value: region.rentRegionId, label: region.rentRegionName }))}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name="title" label="제목">
                                    {editMode === "none" ? <span>{rentCar?.title || String.dash}</span> : <Input placeholder="제목" />}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name="description" label="설명">
                                    {editMode === "none" ? <span>{rentCar?.description || String.dash}</span> : <Input placeholder="설명" />}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name="price" label="가격">
                                    {editMode === "none" ? <span>{rentCar?.price || String.dash}</span> : <Input placeholder="가격" type="number" />}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name="discountPrice" label="할인가">
                                    {editMode === "none" ? <span>{rentCar?.discountPrice || String.dash}</span> : <Input placeholder="할인가" type="number" />}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name="weekendPrice" label="주말가격">
                                    {editMode === "none" ? <span>{rentCar?.weekendPrice || String.dash}</span> : <Input placeholder="주말가격" type="number" />}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name="weekendDiscountPrice" label="주말할인가">
                                    {editMode === "none" ? (
                                        <span>{rentCar?.weekendDiscountPrice || String.dash}</span>
                                    ) : (
                                        <Input placeholder="주말할인가" type="number" />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name="rentRestrictions" label="제약조건">
                                    {editMode === "none" ? (
                                        <span>
                                            {rentCar?.rentRestrictions
                                                ? rentCar.rentRestrictions.map((restriction) => restriction.rentRestrictionName).join(", ")
                                                : String.dash}
                                        </span>
                                    ) : (
                                        <Select
                                            placeholder="제약조건"
                                            mode="multiple"
                                            optionLabelProp="label"
                                            options={restrictions?.map((restriction) => ({
                                                value: restriction.rentRestrictionId,
                                                label: restriction.rentRestrictionName,
                                            }))}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name="rentOptions" label="렌트 옵션">
                                    {editMode === "none" ? (
                                        <span>
                                            {rentCar?.rentOptions ? rentCar.rentOptions.map((option) => option.rentOptionName).join(", ") : String.dash}
                                        </span>
                                    ) : (
                                        <Select
                                            placeholder="렌트 옵션"
                                            mode="multiple"
                                            optionLabelProp="label"
                                            options={options?.map((option) => ({
                                                value: option.rentOptionId,
                                                label: option.rentOptionName,
                                            }))}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name="unavailable" label="운행 가능">
                                    {editMode === "none" ? (
                                        <span>{rentCar?.unavailable ? "불가능" : "가능"}</span>
                                    ) : (
                                        <Radio.Group>
                                            <Radio value={false}>○</Radio>
                                            <Radio value={true}>✕</Radio>
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name="waiting" label="대기 여부">
                                    {editMode === "none" ? (
                                        <span>{rentCar?.waiting ? "대기" : String.dash}</span>
                                    ) : (
                                        <Radio.Group>
                                            <Radio value={true}>○</Radio>
                                            <Radio value={false}>✕</Radio>
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" name="repairing" label="점검 여부">
                                    {editMode === "none" ? (
                                        <span>{rentCar?.repairing ? "점검" : String.dash}</span>
                                    ) : (
                                        <Radio.Group>
                                            <Radio value={true}>○</Radio>
                                            <Radio value={false}>✕</Radio>
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                    <Row justify="end">
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {editMode === "add" ? "등록" : "수정"}
                            </Button>
                        </Form.Item>
                    </Row>
                </Space>
            </Form>
        </div>
    );
}

export default RentCarDetail;
